var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBranch(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M9.93097 0H4.06904C1.51976 0 0 1.51976 0 4.06904V9.93097C0 12.4802 1.51976 14 4.06904 14H9.93097C12.4802 14 14 12.4802 14 9.93097V4.06904C14 1.51976 12.4802 0 9.93097 0Z",
    fill: "#B1B1B1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0852 8.52345C9.65801 7.30484 8.50946 6.48542 7.22081 6.48542C7.21381 6.48542 7.2138 6.48542 7.20679 6.48542L5.76407 6.49241C5.76407 6.49241 5.76407 6.49241 5.75706 6.49241C5.2248 6.49241 4.76257 6.13524 4.6225 5.62399C5.24581 5.42789 5.70107 4.8466 5.70107 4.16026C5.70107 3.31283 5.00771 2.61948 4.16029 2.61948C3.31286 2.61948 2.61951 3.31283 2.61951 4.16026C2.61951 4.78357 2.99769 5.32284 3.52995 5.56096V8.60048C2.99769 8.81058 2.61951 9.32884 2.61951 9.93114C2.61951 10.7225 3.26382 11.3669 4.05522 11.3669C4.84661 11.3669 5.49093 10.7225 5.49093 9.93114C5.49093 9.32183 5.11275 8.81058 4.58048 8.60048V7.18577C4.92365 7.40288 5.32985 7.52894 5.75706 7.52894H5.76407L7.20679 7.52193C8.03321 7.49392 8.76859 8.02619 9.06274 8.79657C8.71957 9.06271 8.49546 9.46891 8.49546 9.93114C8.49546 10.7225 9.13977 11.3669 9.93117 11.3669C10.7226 11.3669 11.3669 10.7225 11.3669 9.93114C11.3739 9.20277 10.8066 8.60049 10.0852 8.52345Z",
    fill: "#052f35 "
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBranch);
export default __webpack_public_path__ + "static/media/branch.a2e62d2e.svg";
export { ForwardRef as ReactComponent };